import React from 'react';
import './home.css';
import { Link } from 'react-router-dom';

const Home = () => {
  return (
    <div className="home-container">
      <div className="hero-section">
        <h1 className="title">GDG On Campus</h1>
        <h2 className="sub-title">Poornima University</h2>
        <p className="description">
          Join a community of passionate developers at Poornima University. Empowering the future of tech.
        </p>
      </div>

      <div className="tech-community">
        <h3 className="section-title">Be a Part of Our Community</h3>
        <p className="section-description">
          Innovate, collaborate, and grow with like-minded developers. Discover events, hackathons, and workshops.
        </p>

        <div className="action-buttons">
        <Link to="https://gdg.community.dev/gdg-on-campus-poornima-university-jaipur-india/" target='main' ><button className="join-button">Join Us</button></Link>
        <Link to="https://instagram.com/gdg.poornima" target='main' ><button className="explore-button">Instagram</button></Link>
        </div>
      </div>

      <div className="event-section">
        <h3 className="section-title">Upcoming Events</h3>
        <div className="event-card">
          <h4 className="event-title">Solution Challenge 2025</h4>
          <p className="event-description">
            Revealing Soon......
          </p>
        </div>

        <div className="event-card">
          <h4 className="event-title">Build With AI 2.0</h4>
          <p className="event-description">
            Revealing Soon......
          </p>
        </div>
      </div>
    </div>
  );
};

export default Home;
